import React from 'react';
import { Rect } from 'react-konva';

const CustomRect = React.memo(({ x, y, width, height, fill, stroke, strokeWidth, dash, draggable = false, onDragEnd }) => {
  return (
    <Rect
      x={x}
      y={y}
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      dash={dash}
      draggable={draggable}
      onDragEnd={onDragEnd}
      perfectDrawEnabled={false}
      ref={(node) => {
        if (node && !draggable) node.cache();
      }}
    />
  );
});

export default React.memo(CustomRect);
